import { useMediaQuery } from "react-responsive"

const IconPanel = (props) => {

    const isMobile = useMediaQuery({ maxWidth: 1280 })

    const { title, iconArray, isOnlyImage } = props


    if (isMobile)
        return (
            <section className="flex w100 white-bkg">
                <section className="flex col acenter jcenter pad-30 main-middle-section-2 icon-panel-section w100 white-bkg">

                    {(!isOnlyImage) ? <h2 className="middle-section-title pad-20">{title}</h2> : <></>}
                    
                    <section className="videoact-logos">
                        {
                            iconArray?.map((icon, index) => {
                                if (isOnlyImage)
                                    return (
                                        <img loading="lazy" key={index} alt={icon.title} className="videoact-logo" src={icon.src} />
                                    )
                                else
                                    return (
                                        <a key={index} title={icon.title} href={icon.href}>
                                            <img loading="lazy" alt={icon.title} className="videoact-logo" src={icon.src} />
                                        </a>
                                    )
                            })
                        }
                    </section>
                </section>
            </section>)
    else
        return (
            <section className="flex acenter jcenter col pad-30 gap-30 main-middle-section-2 icon-panel-section">
                {(!isOnlyImage) ? <h2 className="middle-section-title">{title}</h2> : <></>}

                <section className="videoact-logos">
                    {
                        iconArray?.map((icon, index) => {
                            if (isOnlyImage)
                                return (
                                    <img loading="lazy" key={index} alt={icon.title} className="videoact-logo" src={icon.src} />
                                )
                            else
                                return (
                                    <a key={index} title={icon.title} href={icon.href}>
                                        <img loading="lazy" alt={icon.title} className="videoact-logo" src={icon.src} />
                                    </a>
                                )
                        })
                    }
                </section>
            </section>
        )

}

export default IconPanel

